import { useState } from 'react';

export function useDebounce(delay = 100) {

  const [timeout] = useState<{ value?: NodeJS.Timeout }>({});
  const [lastValue] = useState<{ value?: string }>({});

  return (value: string, cb: (value: string) => void) => {
    clearTimeout(timeout.value);
    timeout.value = setTimeout(() => {
      if (value !== lastValue) {
        cb(value);
        lastValue.value = value;
      }
    }, delay);
  };
}
